import { Editor, Location } from 'slate';

export function isStart(editor: Editor, at: Location) {
    const point = editor.selection?.focus;

    return !!point && Editor.isStart(editor, point, at);
}
